import React, { useContext, useEffect, useState } from 'react'
import { HrmStore } from '../../Context/HrmContext'
import axios from 'axios'
import { port } from '../../App'
import RecordPaymentModal from '../../Components/ClientComponents/RecordPaymentModal'
import AddBillingCycleModal from '../../Components/ClientComponents/AddBillingCycleModal'
import Slider from 'react-slick'
import ShortcutCard from '../../Components/HomeComponent/ShortcutCard'
import { useNavigate } from 'react-router-dom'

const ParticularClientBilling = ({ id }) => {
    let { setActiveSetting, setTopNav, changeDateYear } = useContext(HrmStore)
    const navigate = useNavigate()
    let [billingSummary, setBillingSummary] = useState({
        total_billed: 0,
        total_paid: 0,
        pending_amount: 0,
        overdue_amount: 0
    })
    let [billingCycles, setBillingCycles] = useState([])
    let [showPaymentModal, setShowPaymentModal] = useState(false)
    let [showAddCycleModal, setShowAddCycleModal] = useState(false)
    let [selectedCycle, setSelectedCycle] = useState(null)

    const fetchData = async () => {
        try {
            // Fetch Summary (Query string _t forces browser to bypass cache)
            const summaryRes = await axios.get(`${port}/root/cms/billing-summary/?client_id=${id}&_t=${new Date().getTime()}`)
            setBillingSummary(summaryRes.data)

            // Fetch Cycles
            const cyclesRes = await axios.get(`${port}/root/cms/billing-cycles/?client_id=${id}&_t=${new Date().getTime()}`)
            setBillingCycles(cyclesRes.data)
        } catch (error) {
            console.error("Error fetching billing data", error)
        }
    }

    useEffect(() => {
        setActiveSetting('billing')
        setTopNav('client')
        fetchData()
    }, [id])

    const handleRecordPayment = (cycle) => {
        setSelectedCycle(cycle)
        setShowPaymentModal(true)
    }

    var settings1 = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 900,
        slidesToShow: 4,
        autoplay: true,
        responsive: [
            { breakpoint: 1220, settings: { slidesToShow: 5, slidesToScroll: 1, infinite: true, dots: true } },
            { breakpoint: 800, settings: { slidesToShow: 4, slidesToScroll: 1, infinite: true, dots: true } },
            { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
        ]
    };

    return (
        <div className="mt-4">
            {/* Summary Cards with Slider */}
            <Slider {...settings1} className='py-3 mb-4'>
                <div>
                    <ShortcutCard img={'/assets/Images/circle1.png'}
                        count={`₹${parseFloat(billingSummary.total_billed || 0).toLocaleString()}`} label='Total Billed' />
                </div>
                <div>
                    <ShortcutCard img={'/assets/Images/circle3.png'}
                        count={`₹${parseFloat(billingSummary.total_paid || 0).toLocaleString()}`} label='Total Received' />
                </div>
                <div>
                    <ShortcutCard img={'/assets/Images/circle2.png'}
                        count={`₹${parseFloat(billingSummary.total_pending || 0).toLocaleString()}`} label='Pending Income' />
                </div>
                <div>
                    <ShortcutCard img={'/assets/Images/circle4.png'}
                        count={`₹${parseFloat(billingSummary.total_overdue || 0).toLocaleString()}`} label='Overdue Income' />
                </div>
                {/* --- Phase 2: Profit & Payout Cards --- */}
                <div>
                    <ShortcutCard img={'/assets/Images/circle3.png'}
                        count={`₹${parseFloat(billingSummary.total_payout || 0).toLocaleString()}`} label='Total Payout (Salary)' />
                </div>
                <div className="relative">
                    <ShortcutCard img={'/assets/Images/circle1.png'}
                        count={`₹${parseFloat(billingSummary.total_profit || 0).toLocaleString()}`} label='Net Profit Margin' />
                    <span className="absolute top-2 right-6 bg-green-500 text-white text-[10px] px-1.5 py-0.5 rounded-full fw-bold animate-pulse">Gross</span>
                </div>
            </Slider>

            {/* Header with Add Button */}
            <div className="flex justify-between items-center mb-2 px-1">
                <div className="flex items-center gap-3">
                    <h6 className="fw-bold text-gray-700 m-0 poppins">Billing Cycles</h6>
                    <div className="flex gap-2">
                        <span className="text-[10px] bg-blue-50 text-blue-600 px-2 py-0.5 rounded border border-blue-100 fw-bold uppercase tracking-tighter">Income (Client)</span>
                        <span className="text-[10px] bg-orange-50 text-orange-600 px-2 py-0.5 rounded border border-orange-100 fw-bold uppercase tracking-tighter">Expense (Candidate)</span>
                    </div>
                </div>
                <button 
                    onClick={() => setShowAddCycleModal(true)}
                    className="bluebtn px-3 py-1 rounded text-sm shadow-sm"
                >
                    + Add Cycle
                </button>
            </div>

            {/* Billing Table matching ClientRequirmentTable style */}
            <main className='tablebg my-2 rounded table-responsive h-[55vh] overflow-y-scroll overflow-x-auto'>
                <table className='w-full min-w-[1500px]'>
                    <tr className='sticky top-0 bg-white z-10'>
                        <th className="text-center whitespace-nowrap px-4 py-3 text-sm">SI no</th>
                        <th className="text-left whitespace-nowrap px-4 py-3 text-sm">Candidate Name</th>
                        <th className="text-left whitespace-nowrap px-4 py-3 text-sm">Requirement</th>
                        <th className="text-center whitespace-nowrap px-4 py-3 text-sm">Month</th>
                        <th className="text-center whitespace-nowrap px-4 py-3 text-sm">Billed Amt</th>
                        <th className="text-center whitespace-nowrap px-4 py-3 text-sm">Payout (Sal)</th>
                        <th className="text-center whitespace-nowrap px-4 py-3 text-sm">Margin</th>
                        <th className="text-center whitespace-nowrap px-4 py-3 text-sm">Due Date</th>
                        <th className="text-center whitespace-nowrap px-4 py-3 text-sm">Income Status</th>
                        <th className="text-center whitespace-nowrap px-4 py-3 text-sm">Payout Status</th>
                        <th className="text-center whitespace-nowrap px-4 py-3 text-sm">Cycle Type</th>
                        <th className="text-center whitespace-nowrap px-4 py-3 text-sm">Action</th>
                    </tr>
                    {billingCycles.length > 0 ? (
                        billingCycles.map((cycle, index) => (
                            <tr key={cycle.id} className='hover:bg-slate-50 transition-colors border-b border-gray-100 group poppins'>
                                <td className="text-center px-4 py-3 text-gray-400">{index + 1}</td>
                                <td className="text-left px-4 py-3 fw-bold text-gray-800 whitespace-nowrap">
                                    <div 
                                        className="flex items-center gap-1 cursor-pointer hover:text-blue-600 transition-colors"
                                        onClick={() => navigate(`/client/candidate-financial/${cycle.joining_details}`)}
                                        title="View Detailed Financial Ledger"
                                    >
                                        {cycle.candidate_name}
                                        {cycle.is_contract_basis && <span className="bg-orange-500 w-1.5 h-1.5 rounded-full" title="Contract Basis"></span>}
                                    </div>
                                </td>
                                <td className="text-left px-4 py-3 text-gray-600 whitespace-nowrap text-sm">{cycle.requirement_title}</td>
                                <td className="text-center px-4 py-3 whitespace-nowrap text-gray-600 text-sm fw-bold">{cycle.cycle_month}</td>
                                
                                {/* Client Billing (Income) */}
                                <td className="text-center px-4 py-3 fw-bold text-blue-600 whitespace-nowrap text-sm">
                                    ₹{parseFloat(cycle.billing_amount).toLocaleString()}
                                </td>

                                {/* Candidate Payout (Expense) */}
                                <td className="text-center px-4 py-3 fw-bold text-orange-600 whitespace-nowrap text-sm">
                                    {cycle.is_contract_basis 
                                        ? `₹${parseFloat(cycle.candidate_payout_amount || 0).toLocaleString()}`
                                        : <span className="text-gray-300 font-normal italic">Fixed</span>}
                                </td>

                                {/* Margin */}
                                <td className="text-center px-3 py-3 fw-bold text-green-700 whitespace-nowrap text-sm">
                                    ₹{parseFloat(cycle.net_profit || 0).toLocaleString()}
                                </td>

                                <td className="text-center px-2 py-3 whitespace-nowrap text-gray-500 text-sm">{cycle.due_date && changeDateYear(cycle.due_date)}</td>
                                
                                {/* Income Status */}
                                <td className="text-center px-4 py-3">
                                    <div className="flex justify-center">
                                        <span className={`px-2 py-1 text-[11px] fw-bold uppercase whitespace-nowrap ${
                                            cycle.status === 'paid' ? 'text-green-500' :
                                            cycle.status === 'partial' ? 'text-purple-500' :
                                            cycle.status === 'overdue' ? 'text-red-500' :
                                            'text-yellow-500' 
                                        }`}>
                                            {cycle.status}
                                        </span>
                                    </div>
                                </td>

                                {/* Payout Status */}
                                <td className="text-center px-4 py-3">
                                    <div className="flex justify-center">
                                        {!cycle.is_contract_basis ? (
                                            <span className="text-gray-300 text-[11px] uppercase fw-bold italic">N/A</span>
                                        ) : (
                                            <span className={`px-2 py-1 text-[11px] fw-bold uppercase whitespace-nowrap ${
                                                cycle.payout_status === 'paid' ? 'text-green-500' :
                                                cycle.payout_status === 'partial' ? 'text-purple-500' :
                                                'text-yellow-500' 
                                            }`}>
                                                {cycle.payout_status || 'Pending'}
                                            </span>
                                        )}
                                    </div>
                                </td>

                                <td className="text-center px-4 py-3">
                                    <div className="flex justify-center">
                                        <span className={`px-2 py-1 text-[12px] fw-semibold whitespace-nowrap ${
                                            cycle.billing_mode 
                                        }`}>
                                            {cycle.billing_mode === 'one_time' ? 'One-Time' : 'Monthly'}
                                        </span>
                                    </div>
                                </td>
                                <td className="text-center px-4 py-3 whitespace-nowrap">
                                    {cycle.status === 'paid' && (!cycle.is_contract_basis || cycle.payout_status === 'paid') ? (
                                        <div className="text-[12px] text-green-600 fw-bold px-2 py-1  inline-block">
                                            Completed
                                        </div>
                                    ) : (
                                        <button
                                            onClick={() => handleRecordPayment(cycle)}
                                            className="bluebtn px-3 py-1.5 rounded text-[11px] fw-bold uppercase tracking-widest shadow-sm whitespace-nowrap"
                                        >
                                            {cycle.status === 'paid' ? 'Update Payout' : 'Track Funds'}
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="8" className="text-center py-5 italic text-gray-500">
                                No billing cycles found for this client.
                            </td>
                        </tr>
                    )}
                </table>
            </main>

            {/* Payment Modal */}
            {selectedCycle && (
                <RecordPaymentModal 
                    show={showPaymentModal} 
                    setshow={setShowPaymentModal} 
                    cycle={selectedCycle} 
                    onSuccess={fetchData}
                />
            )}

            {/* Add Cycle Modal */}
            <AddBillingCycleModal 
                show={showAddCycleModal} 
                setshow={setShowAddCycleModal} 
                client_id={id} 
                onSuccess={fetchData} 
            />
        </div>
    )
}

export default ParticularClientBilling
